import React from "react";
import { View, Text, StyleSheet } from "react-native";
import Colors from "@constants/Colors";

export type TtgoStatus = "pending" | "approved" | "rejected";

const STYLE_MAP: Record<TtgoStatus, { label: string; bg: string }> = {
  pending: { label: "申請中", bg: "#FFA500" },
  approved: { label: "承認済", bg: "#14CAE2" },
  rejected: { label: "却下", bg: "#FF5E2B" },
};

export default function TtgoStatusBadge({ status }: { status: TtgoStatus }) {
  const { label, bg } = STYLE_MAP[status];
  return (
    <View style={[styles.badge, { backgroundColor: bg }]}>
      <Text style={styles.text}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 10,
    alignSelf: "flex-start",
  },
  text: {
    color: Colors.white,
    fontSize: 11,
    fontWeight: "600",
  },
});
